import Styled from 'styled-components';

const getBackgroundColorStyle = (props, opaque) => {
	let color = null;
	if (props.cardDisabled) color = opaque ? props.theme.colors.opaqueGray : props.theme.colors.nonOpaqueGray;
	else if (props.isSelected) color = props.theme.colors.forecastPurpleLight;
	else if (props.isFavoured) color = props.theme.colors.starYellowLight;
	else color = props.theme.colors.white;
	return `background-color: ${color}`;
};

const getBorderColor = props => {
	if (props.cardDisabled) return props.theme.colors.opaqueGray;
	if (props.isSelected) return props.theme.colors.forecastPurple;
	if (props.isFavoured) return props.theme.colors.starYellowLight;
	else return props.theme.colors.white;
};

/******************************
 * card.js
 ******************************/

export const GroupedItems = Styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
`;

export const ProgressBar = Styled.div`
	position: absolute;
	bottom: ${props => (props.isSelected ? '2px' : '0px')};
	left: ${props => props.isSelected && '2px'};
	height: ${props => (props.isSelected ? '2px' : '3px')};
	width: ${props => (props.isSelected ? 'calc(100% - 4px)' : '100%')};
	z-index: 10;

	.progress-bar-container {
		position: relative;
		height: 100%;
		width: 100%;
		background-color: rgba(129, 192, 247, 0.3);
	}
	.progress-bar {
		position: absolute;
		width: ${props => `${props.progress}%`};
		height: 100%;
		background-color: ${props => (props.progress < 100 ? 'rgb(129, 192, 247)' : 'rgb(109, 212, 0)')};
	}
 `;

export const TopLineItemHover = Styled.div`
	margin-right: ${props => !props.last && '8px'};
	padding: 0;
	display: none;
	align-items: center;	
`;

export const CardHoverItem = Styled.div`
	margin-right: 8px;
	display:none;
	align-items: center;
`;

export const Container = Styled.div`
	height: ${props => props.height && `${props.height}px`};
	position: relative;
	.time-registration-icon {
		opacity: 0.0;

		
		}

	.active.time-registration-icon {
		opacity: 1.0;	
	}
	cursor: ${props => (props.cardDisabled ? 'pointer' : 'grab')};
	outline: none;
	width: 100%;
	&:hover {
		 .time-registration-icon {
			opacity: 1.0;	
		}
		div.shadow-box {
			box-shadow: ${props => !props.cardDisabled && '0 4px 8px 0 rgba(0, 0, 0, 0.15)'};
		}
	}
	&:hover ${TopLineItemHover},
	&:hover ${CardHoverItem} {
		display: flex;
	}

`;

export const ShadowBox = Styled.div`
	box-sizing: border-box;
	position: absolute;
	width: 100%;
	height: calc(100% - 7px);
	bottom: 0;
	box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.05);
	border-left: ${props => '2px solid ' + getBorderColor(props)};
	border-right: ${props => '2px solid ' + getBorderColor(props)};
	border-bottom: ${props => '2px solid ' + getBorderColor(props)};
	z-index:1;
	${props => getBackgroundColorStyle(props, true)};

`;

export const ContentContainer = Styled.div`
	z-index: 1;
	position: relative;
	width: 100%;
	height: calc(100% - 11px);
	padding: 0 16px 12px;
	overflow:visible;
	background-color: transparent;


	box-sizing: border-box;

`;

export const TopLine = Styled.div`
	display: flex;
	justify-content: space-between;
	height: 18px;
	align-items: center;
`;

export const TopLineSection = Styled.div`
	display: flex;
	align-items: center;
	height: 100%;

`;

export const TopLineItem = Styled.div`
	margin-right: ${props => !props.last && '8px'};
	padding: 0;
	display: flex;
	align-items: center;	
`;

export const IdText = Styled.div`
	display: inline-block;
	font-weight: 700;
	font-size: 12px;
	padding: 0;
	margin: 0;
	color: rgb(161, 161, 161);
`;

export const DeadlineSection = Styled.div`
	margin: 16px 0 0 0;
	display: block;
	font-size: 13px;
	font-weight: 400;
	p {
		display: inline-block;
		color: #a1a1a1;

		margin: 0 4px 0 0;
	}
`;

export const ClientSection = Styled.div`
	display: block;
	font-size: 13px;
	font-weight: 400;
	p {
		display: inline-block;
		color: #a1a1a1;

		margin: 0 4px 0 0;
	}
`;

export const ParentTaskNameSection = Styled.div`
	margin: 16px 0 0 0;
	display: block;
	font-size: 11px;
	font-weight: 400;
	p {
		margin-top: 0px;
		margin-bottom: 0px;
		display: inline-block;
		color: #a1a1a1;
	}
`;

export const SubTaskIconItem = Styled.div`
	align-self: flex-start;
	margin: 4px 4px 0 0;
`;

export const DateText = Styled(IdText)`	
	font-size: 11px;
	font-weight: 400;
	color: '#535353';
`;

export const NameText = Styled.div`
	padding: 0;
	font-size: 13px;
	margin: ${props => (props.parentTask ? '4px 0 0 0' : '16px 0 0 0')};
	font-weight: 400;
	overflow: hidden;
	text-overflow: ellipsis;
	color: ${props => props.theme.colors.textGray};
	
	span {
		margin-right: 5px;
	}
`;

/******************************
 * top_bar_and_chip.js
 ******************************/
export const TopBar = Styled.div`
	height: 12px;
	width: 100%;
	z-index: 1;
	margin-bottom: -1px;
	position: relative;
	box-sizing: border-box;
`;
export const Chip = Styled.div`
	outline: none;
	position: absolute;
	right: 1.7px;
	top: 2.5px;
	width: 21px;
	height: 10px;
	transform: rotate(20deg);
	${props => getBackgroundColorStyle(props)};
	overflow:hidden;
	border-top: ${props => '2px solid ' + getBorderColor(props)};
`;

export const LeftBar = Styled.div`
	height: 100%;
	width: calc(100% - 21px);
	${props => getBackgroundColorStyle(props)};
	border-top: ${props => '2px solid ' + getBorderColor(props)};
	border-left: ${props => '2px solid ' + getBorderColor(props)};

`;

export const ContentLineSection = Styled.div`
	position: relative;
	overflow: hidden;
	text-overflow: ellipsis;
	display:flex;
	flex-direction:row;
	align-items:baseline;
`;

export const LabelsSection = Styled.div`
	display: block;
	margin-top: 12px;
	position: relative;
	z-index: 0;
	width:100%;
`;

export const ImageSection = Styled.div`
	background-color: #fff;
	border-radius: 4px;
	cursor: pointer;
	display: block;
	margin-top: 12px;
	min-height: 20px;
	position: relative;
	text-decoration: none;
	z-index: 0;
	width:100%;
`;

export const ImageWrapper = Styled.div`
	background-color: white;
	
	background-image: url("${props => props.url}");
	background-size: contain;
	background-position: 50%;
	background-repeat: no-repeat;
	user-select: none;
`;

export const BottomLine = Styled.div`
	display:flex;
	margin-top: 12px;
	flex-direction:row;
	align-items: center;
	justify-content: space-between;
	max-height:26px;
`;

export const DetailsSection = Styled.div`
	display:flex;
	flex-direction:row;
	font-size: 10px;
	font-weight: 500;
	color:${props => props.theme.colors.textGray};
`;

export const DetailElement = Styled.div`
	display:flex;
	flex-direction:row;
	margin-right: 15px;
	> span{
		margin-right:4px;
	}
`;

export const BottomLineDetailElement = Styled.div`
	margin-right: 4px;
	padding-top: 1px;
`;

/******************************
 * Loader
 ******************************/

export const LoadingLineWrapper = Styled.div`
	display:flex;
	flex-direction:column;
	width:100%;
`;

export const LoadingLine = Styled.div`
	width:${props => (props.small ? '33%' : '100%')};
	height:10px;
	background:${props => props.theme.colors.fixedElementGrey};
	margin-bottom:8px;
 `;
